import Helper from '@ember/component/helper';
import { service } from '@ember/service';

export default class GreetingHelper extends Helper {
  // Services
  @service intl;

  // Getter and setter
  get randomGreet() {
    let greets = [
      'servus',
      'moin',
      'welcome',
      'hello',
      'hola',
      'ola',
      'bonjour',
      'ciao',
      'ahoj',
      'pozdrav',
      'salve',
      'niHao',
      'hei',
    ];
    let greet = greets[Math.floor(Math.random() * greets.length)];

    return this.intl.t(`greeting.${greet}`);
  }

  // Hooks
  compute([user]) {
    return `${this.randomGreet} ${user?.get('firstname')}!`;
  }
}
